import React from "react";

function Step() {
  return null;
}

export default Step;
